export default __webpack_public_path__ + "static/media/notvarified.3c70872b.svg";